import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import {
  FormGroup,
  FormControl,
  ValidatorFn,
  NgForm,
  ReactiveFormsModule,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ModalPromptComponent } from "../../../../_helpers/Modals/prompt/modal.prompt";
import { Constants } from "../../../../_utils/Constants";
import { APILoginService } from "../../_services/login/API-login";
import { APIEntityService } from "../../_services/entity/API-entity";
import { VoiceService } from "../../_services/voice/voice";
import { LoginComponent } from "../login/login.component";
import { $ModalManagerService } from "../../../../_helpers/Modals/ModalManager.service";
import { $DBManagerService } from "../../../../_helpers/DB/DBManager.service";
import * as crypto from "crypto-js";
import { $BroadcastManagerService } from "../../../../_helpers/BroadcastManager.service";
import { APIConstants } from "../../../../_config/restapis";
import { formatDate } from "@angular/common";
import { MustMatch } from "../../../../_helpers/must-match-validator";

import * as CryptoJS from "crypto-js";
import { Observable } from "rxjs/Observable";
import { ModalPromptEntityComponent } from "../../../../_helpers/Modals/prompt-entity/modal.prompt-entity";

const now = new Date();
const currentdat = formatDate(now, "yyyy-MM-dd", "en-US", "+0530");

@Component({
  selector: "app-voice-header-modification-tm",
  templateUrl: "./voice-header-modification-tm.component.html",
  styleUrls: ["./voice-header-modification-tm.component.css"],
})
export class VoiceHeaderModTMComponent implements OnInit {
  response: any;
  tmId: any;
  tmname: any;
  tm_supportdoc: any;
  Entity_OrganizationName: any;
  voiceheaderForm: FormGroup;
  isValidcancel: boolean = false;
  isValidmodify: boolean = false;
  UrnNum: any;
  docfiles5: any;
  photoName2: any;
  downloadnow: boolean = false;
  dontremove: boolean = false;
  document3: any[] = [];
  fileExtensionError: boolean = false;
  fileSizeError1: boolean = false;
  fileSizeError2: boolean = false;
  fileExtension: any;
  fileExtensionMessage: string;
  photoContent: any;
  myfiles: any;
  peRemarks: string;
  poRemarks: string;
  peSubmitted: boolean = false;
  message: string;
  sentback: any;
  sentbackaction: string = '';
  public modalRef: BsModalRef;
  returnedValue: any;

  get f() {
    return this.voiceheaderForm.controls;
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  constructor(
    private fb: FormBuilder,
    private ls: APIEntityService,
    private vs: VoiceService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService
  ) {
    this._route.params.subscribe((params) => {
      this.UrnNum = params["urn"];
      this.tmId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
      this.tmname = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
    });

  }

  ngOnInit() {
    this.voiceheaderForm = this.fb.group({
      urn: [""],
      tm_id: [""],
      tm_supportdoc: [""],
      tm_name: [""],
      entity_id: [""],
      pe_name: [""],
      header_id: [""],
      tmremarks: [
        "",
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(1000),
          Validators.pattern("^(?! ).*(?<! )$"),
        ],
      ],
      prevtmremarks: [""],
      pe_comments: [""],
      tsp_comments: [""],
    });

    console.log("----tm id and name----------", this.tmId, this.tmname);
    console.log("-----------------Inititalization------");
    this.voiceheaderForm.controls["urn"].setValue(this.UrnNum);
    this.voiceheaderForm.controls["tm_id"].setValue(this.tmId);
    this.voiceheaderForm.controls["tm_name"].setValue(this.tmname);

    this.getVoiceHeaderRec(this.UrnNum);
  }


  entityname(filterValue: string) {
    console.log("in filter");
    let data = {
      PEID: filterValue.trim(),
    };

    //console.log("--------data---", data);
    this.vs.getentityname(data).subscribe((r) => {
      //console.log("-----------r----", r);
      if (r.status == "success") {
        this.voiceheaderForm.controls["pe_name"].setValue(r.message);
        this.voiceheaderForm.controls["pe_name"].disable();
      } else {
        this.$modal.errorModal({
          title: "Voice header by TM - Modification",
          msg: r.message,
        });
      }


    });
  }

  download(file1) {
    var data = {
      Ref_No: this.UrnNum,
      Folder: "TMDOCs",
      FileName: file1,
    };
    this.vs.downloadFilenow(data).subscribe((r) => {
      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: " Voice Header",
        msg: "File has been downloaded Successfully",
      });
    });
  }

  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  getVoiceHeaderRec(urn) {
    let data = {
      urn: urn,
    };
    this.vs
      .getVoiceHeaderDetailsbyURN(data)

      .subscribe((r) => {
        //console.log("---------responese-----", r);
        if (r.status == "success") {
          this.voiceheaderForm.controls["entity_id"].setValue(
            r.message[0].peid
          );
          this.voiceheaderForm.controls["pe_name"].setValue(
            r.message[0].pename
          );
          this.voiceheaderForm.controls["header_id"].setValue(r.message[0].cli);
          this.voiceheaderForm.controls["prevtmremarks"].setValue(
            r.message[0].TMComments
          );

          if(r.message[0].sts !== 'PT') {
            this.isValidmodify = true;
          }
          if (r.message[0].Hash_DocsByTM) {
            //console.log("--------------r.message[0].tm_supportdoc-------", r.message[0].Hash_DocsByTM);

            this.docfiles5 = r.message[0].Hash_DocsByTM;
            this.photoName2 = r.message[0].Hash_DocsByTM.substring(r.message[0].Hash_DocsByTM.indexOf(".") + 1);

            console.log("---------------photoName-------", this.photoName2);
          } else {
            this.downloadnow = true;
          }

          this.sentback = r.message[0].SentBackBy;
          //console.log("---------sentback----r.message[0].PEComments-----", this.sentback, r.message[0].PEComments)

          if (this.sentback == 'PE' && r.message[0].PEComments) {
            console.log("---------in PE--")
            this.voiceheaderForm.controls["pe_comments"].setValue(r.message[0].PEComments);
            this.sentbackaction = 'PP'

            if (r.message[0].ModCountByRegtoPE > parseInt(Constants.MAXCNTBYREGTOPE)) {
              this.isValidmodify = true
              alert("Please cancel the request and reinitate new, as PE exceeded the maximum modification count")
            }
            if (r.message[0].ModCountByPEtoTM > parseInt(Constants.MAXCNTBYPETOTM)) {
              this.isValidmodify = true
              alert("Please cancel the request and reinitate new, as you have exceeded the maximum modification count")
            }

          }
          if (this.sentback == 'TSP' && r.message[0].RegComments) {
            console.log("---------in TSP--")
            this.voiceheaderForm.controls["tsp_comments"].setValue(r.message[0].RegComments);
            this.sentbackaction = 'PP'
            if (r.message[0].ModCountByRegtoTM > parseInt(Constants.MAXCNTBYREGTOTM)) {
              this.isValidmodify = true
              alert("Please cancel the request and reinitate new, as you have exceeded the maximum modification count")
            }

          }
        } else {
          this.$modal.errorModal({
            title: "Voice header by TM - Modification",
            msg: r.message,
          });
        }
      });
  }


  retrive() {
    this.resetDoc3();
    this.voiceheaderForm.controls["tmremarks"].setValue('');
    this.getVoiceHeaderRec(this.UrnNum);
  }

  cancel() {

    let tmremarks = this.voiceheaderForm.get("tmremarks").value;
    if(tmremarks == undefined || tmremarks == '') {
      alert("Please fill TM Remarks")
    } else {
    this.modalRef = this.modalService.show(ModalPromptComponent)
    this.modalRef.content.modalDataObj = {
      title: "Voice header by TM - Modification",
      msg: "Request will be closed without any action and released into freepool. Request for re-registration of header can be initiated by any TM after 3 days, would you like to still continue"
    }

    this.modalRef.content.onClose.subscribe(result => {
      this.returnedValue = result
     // console.log("results", result)

      if (this.returnedValue == true) {
        this.sentbackaction = 'CT'
        this.VoiceHeaderMod();
      }
    })
    }
  }

  onChangeFileUpload(event) {
    this.myfiles = event.target.files;
    var file = event.target.files[0];

    let fileNameArr = file.name.split(".");
    if (fileNameArr.length > 2) {
      this.$modal.errorModal({
        title: "Header Modification",
        msg: "Can't upload file with two extension!, please upload again.",
      });
      this.resetDoc3();
    } else {
      this.photoName2 = file.name;
      this.docfiles5 = this.document3.push(file);
      console.log("---  this.docfiles5--", this.docfiles5);
      console.log("---  this.doc1--", this.document3[0]);
      if (file.size > 4242880) {

        this.fileSizeError1 = true;
      } else {
        this.fileSizeError1 = false;
      }
      if (file.size <= 0) {

        this.fileSizeError2 = true;
      } else {
        this.fileSizeError2 = false;
      }

      var allowedExtensions = [
        "jpg",
        "jpeg",
        "png",
        "JPG",
        "JPEG",
        "JFIF",
        "BMP",
        "SVG",
        "pdf",
        "PNG",
        "msg",
        "MSG",
        "zip",
        "ZIP",
      ];
      this.fileExtension = this.photoName2.split(".").pop();
      //console.log("this.photoName   ----------- ", this.photoName2)

      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        this.fileExtensionError = false;
        this.fileExtensionMessage = "";
      } else {
        this.$modal.errorModal({
          title: 'Wrong Format',
          msg: 'Please upload the files in specified format.'
      });
        //this.fileExtensionMessage = "Only photos allowed!!";
        this.fileExtensionError = true;
        this.resetDoc3();
      }

      if (file) {
        var reader = new FileReader();
        reader.onloadend = (e: any) => {
          var content = e.target.result;
          this.photoContent = content;
        };
        reader.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
    }


  }

  onSubmit() {

   // console.log("----------submit form---------------", this.voiceheaderForm);

    if (this.voiceheaderForm.invalid) {
      console.log("--------------invalid----");
      let invalid = [];
      let controls = this.voiceheaderForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      return;
    }
    console.log("----------submit form-----2----------");

    this.VoiceHeaderMod();
  }

  resetDoc3() {
    this.voiceheaderForm.controls["tm_supportdoc"].reset();
    this.document3 = [];
    this.docfiles5 = null;
    // this.docfiles5 = (this.docfiles5 != "" || this.docfiles5 != null) ? this.docfiles5 : null;
    this.fileExtensionError = false;
    this.fileSizeError1 = false;
    this.fileSizeError2 = false;
  }

  VoiceHeaderMod() {

    const voiceheaderForm: FormData = new FormData();
   // console.log("------------in fn-----", this.voiceheaderForm);

    let Entity_OrganizationName = this.voiceheaderForm.get("pe_name").value;
    let Entityid = this.voiceheaderForm.get("entity_id").value;
    let Header_ID = this.voiceheaderForm.get("header_id").value;
    let tmRemarks = this.voiceheaderForm.get("tmremarks").value;
    let tm_supportdoc = this.voiceheaderForm.get("tm_supportdoc").value;
    let action = this.sentbackaction;
    console.log("---------action-----", action)

    voiceheaderForm.append("TMID", this.tmId);
    voiceheaderForm.append("TMNAME", this.tmname);
    voiceheaderForm.append("PEID", Entityid);
    voiceheaderForm.append("PENAME", Entity_OrganizationName);
    voiceheaderForm.append("CLI", Header_ID);
    voiceheaderForm.append("tm_supportdoc", this.document3[0]);
    voiceheaderForm.append("TMRemarks", tmRemarks);
    voiceheaderForm.append("action", action);
    voiceheaderForm.append("urn", this.UrnNum);


   // console.log("---------voiceheaderForm--------", voiceheaderForm);
    this.vs.VoiceHeaderModTM(voiceheaderForm)
      .subscribe((r) => {
        console.log("---response---------", r);
        if (r.status == "success") {
          if (action == 'CT') {
            this.$modal.successModal({
              title: "Voice Header Cancellation",
              msg: "Your voice header request has been succesfully cancelled. URN-" + r.message.urn,
            });

          }
          else {
            this.$modal.successModal({
              title: "Voice header by TM - Modification",
              msg: "Your voice header modification has been succesfully sent to PE. URN-" + r.message.urn,
            });
          }
          this.isValidmodify = true;
          this.isValidcancel = true;
          this.dontremove = true;
          this.router.navigateByUrl("/voice-header-reg-list-tm");

        } else {
          if (r.message) {

            this.$modal.errorModal({
              title: "Voice header by TM - Modification",
              msg: r.message,
            });
          } else {
            this.$modal.errorModal({
              title: "Voice header by TM - Modification",
              msg: "Error updating Modification!",
            });
          }
        }
      });
  }
}
